import SITE_PATHS from '../config/sitePaths';

const getConsoleV2Url = () => {
  const currentPage = new URL(window.location);
  if (currentPage.hostname === 'localhost') {
    currentPage.port = '3000';
    return currentPage.href;
  }
  return [
    SITE_PATHS.CONSOLE_V2,
    window.location.pathname,
    window.location.search,
  ].join('');
};

export default getConsoleV2Url;
